import React, { FC } from "react";
import { useNavigate } from 'react-router-dom';
import { NegativePriceMetricsProps } from "./NegativePriceMetricsContainer.types";
import { DashboardContainer, ContainerContent, DashboardContainerHeader, DashboardContainerBody, H3 } from "../MoaDashboard.styles";
import EventCount from "../EventCount";

const NegativePriceMetrics: FC<NegativePriceMetricsProps> = (
    {
      negativePriceMetrics,
      setOpenDrawer,
      setDrawerType,
      isLoading,
      setFetchNegativePrices,
      setDrawerColumnDefs
    }
) => {
  const navigate = useNavigate();

  const negativePriceColumnDefs = [
    {
      minWidth: 100, field: 'store', headerName: 'Store', sortable: true, floatingFilter: false
    },
    {
      minWidth: 150,
      field: 'menu',
      headerName: 'Menu',
      sortable: true,
      floatingFilter: false,
      cellRenderer: (params: any) => {
        const handleMenuClick = (e: React.MouseEvent) => {
          e.preventDefault();
          navigate(`/menus/${params.value}`);
        };

        return (
            <span
                onClick={handleMenuClick}
                style={{
                  color: '#1976d2',
                  cursor: 'pointer',
                  textDecoration: 'underline'
                }}
            >
              {params.value}
            </span>
        );
      }
    },
    {
      minWidth: 120, field: 'bundle', headerName: 'Bundle', sortable: true, floatingFilter: false
    },
    {
      minWidth: 150, field: 'recipe', headerName: 'Recipe', sortable: true, floatingFilter: false
    },
    {
      minWidth: 100, field: 'price', headerName: 'Price', sortable: true, floatingFilter: false
    }
  ];

  const openNegativePriceDrawer = () => {
    setFetchNegativePrices(true);
    setDrawerColumnDefs(negativePriceColumnDefs);
    setDrawerType('negativePrices');
    setOpenDrawer(true);
  }

  return (
      <DashboardContainer style={{ width: '85%' }} data-testid={'negativePriceMetricsContainer'}>
        <DashboardContainerHeader data-testid="negativePriceMetricsContainerHeader">
          Negative Price Metrics
        </DashboardContainerHeader>
        <DashboardContainerBody>
          <ContainerContent style={{ position: 'relative', flexGrow: '3', justifyContent: 'space-between' }}>
            <EventCount
                label={'Menus'}
                count={negativePriceMetrics?.menus}
                isLoading={isLoading}
                testId={'negativePriceCount'}
            />
            {!isLoading && negativePriceMetrics?.menus !== 0 &&
              <H3
                label={'See details'}
                onClick={openNegativePriceDrawer}
                style={{ paddingRight: '1rem' }}
                dataTestId="seeNegativePriceDetails"
                to={''}
              />
            }
          </ContainerContent>
        </DashboardContainerBody>
      </DashboardContainer>
  );
}

export default NegativePriceMetrics;